const Marquee = ({ items }) => (
  <div className="relative overflow-hidden border-y border-zinc-800/60 bg-void-2/60 py-6" data-testid="services-marquee">
    <div className="marquee-track flex w-max whitespace-nowrap">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center" aria-hidden={half === 1}>
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="font-display text-lg sm:text-xl font-bold uppercase tracking-[0.15em] text-zinc-500 px-8">
                {item}
              </span>
              <span className="w-2 h-2 rotate-45 bg-[#C5A059]/70 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
